export const featureToggleNames = [
    'smartLinking',
    'organizationClientInvoicing',
    'organizationProvisionedMedicalProfiles',
] as const;

export type FeatureToggleName = (typeof featureToggleNames)[number];
